import { render, staticRenderFns } from "./portfolioCompare.vue?vue&type=template&id=e0ef0106&scoped=true&"
import script from "./portfolioCompare.vue?vue&type=script&lang=js&"
export * from "./portfolioCompare.vue?vue&type=script&lang=js&"
import style0 from "./portfolioCompare.vue?vue&type=style&index=0&id=e0ef0106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ef0106",
  null
  
)

export default component.exports